import { TradingSessionsTable } from '../../TradingSessionsTable/TradingSessionsTable';
import { useSettingsState } from '../SettingsState';

export const ManageSessionsPanel = () => {
  const pushPanel = useSettingsState(({ pushPanel }) => pushPanel);
  const setSignerToRevoke = useSettingsState(({ setSignerToRevoke }) => setSignerToRevoke);

  const handleRevoke = (signerAddress: `0x${string}`) => {
    setSignerToRevoke(signerAddress);
    pushPanel('revoke');
  };

  return (
    <div className="p-4">
      <TradingSessionsTable onRevoke={handleRevoke} disableRevoke={false} />
    </div>
  );
};
